import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProcessoGrupoService } from '../../../services/processo-grupo.service';
import { ProcessoGrupo } from '../../../models/processo-grupo.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';

@Component({
  selector: 'app-grupo-edit',
  templateUrl: './grupo-edit.component.html',
  styleUrls: ['./grupo-edit.component.scss']
})
export class GrupoEditComponent extends BaseFormComponent<ProcessoGrupo> implements OnInit {

  id_aba: number;
  process_id: number;
  infoProcesso:any = {process_id:false};

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ProcessoGrupoService,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    //this.initForm();
    this.id_aba = this.activatedRoute.snapshot.params?.id;
    
    if(this.entity){
      this.id_aba = this.entity.id_aba;
    }else{
      this.infoProcesso = this.activatedRoute.snapshot.data["infoProcesso"];
    }
    
    this.initForm()
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
      ]),
      id_aba:new FormControl(this.id_aba),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  getDataCreate(): ProcessoGrupo {
    let data: ProcessoGrupo;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProcessoGrupo) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProcessoGrupo) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['/pre-projeto', 'processos', 'grupos', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'processos',this.entity.process_id, 'grupos', ]);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  voltar() {
    if(this.infoProcesso.process_id){
      this.navigation.replace(['/pre-projeto', 'processos', this.infoProcesso.process_id, 'grupos']);
    }else{
      this.navigation.replace(['/pre-projeto', 'processos',this.entity.process_id, 'grupos', ]);
    }
  }

}
  
